<template>
    <div class="pt-10">
        <div class="relative mb-6">
            <div class="absolute w-full flex justify-center bottom-0">
                <div class="w-32 h-20 campaign-image rounded-md overflow-hidden">
                    <div :style="{'background-image': `url('${serialModel.campaignImgUrl}')`}"></div>
                </div>
            </div>
        </div>
        <div class="mb-6">
            <div class="text-center text-18 text-im-black-232323 font-bold px-4">
                {{serialModel.campaignName}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SerialDetail",
    props: {
        serialModel: Object,
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        div {
            @include boxRatio(66.66%);
        }
    }
</style>
